module.exports = __webpack_public_path__ + "static/media/214x152_10 copy.1cc44b5a.png";